import { jwtDecode } from "jwt-decode";

export function isTokenExpired(token) {
  if (!token) {
    return true;
  }
  try {
    const decoded = jwtDecode(token);
    if (!decoded || !decoded.exp) return true;

    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Invalid token", error);
    return true;
  }
}
